import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { consumeNext, handleOidcCallback } from '@/auth/oidc'
import '@/styles/app.css'

export function CallbackPage() {
  const navigate = useNavigate()
  const [message] = useState('Signing you in…')

  useEffect(() => {
    let cancelled = false
    void (async () => {
      const result = await handleOidcCallback()
      if (cancelled) return
      history.replaceState({}, '', '/callback')

      if (!result.ok) {
        const reason = result.reason === 'missing-code' ? 'denied' : 'error'
        navigate(`/login?reason=${reason}`, { replace: true })
        return
      }

      navigate(consumeNext('/home'), { replace: true })
    })().catch(() => {
      if (!cancelled) navigate('/login?reason=error', { replace: true })
    })
    return () => {
      cancelled = true
    }
  }, [navigate])

  return (
    <div className="sm-login">
      <div className="sm-login-bg" aria-hidden="true" />
      <div className="sm-login-card sm-login-card--center">
        <p className="sm-login-lede" style={{ margin: 0 }}>
          {message}
        </p>
      </div>
    </div>
  )
}
